module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Fey-2f5fd69e7b3f1b29ad237e44b2abf930.png";